import React from "react";
import { Card, CardContent, Stack, Box, Typography, Divider } from "@mui/material";
import { User } from "react-feather";
import { SectionTitle } from "./UiBits";

export default function BenchmarkCard({ theme, cardSx, contentSx, data, riskScore }) {
  return (
    <Card sx={cardSx}>
      <CardContent sx={contentSx}>
        <SectionTitle icon={<User size={18} />} title="Benchmark di Settore" />

        <Stack spacing={2.25}>
          <Box>
            <Stack direction="row" justifyContent="space-between" alignItems="center">
              <Typography variant="body2" color="text.secondary" sx={{ fontSize: 13.5 }}>
                Risk Score
              </Typography>
              <Typography sx={{ fontWeight: 900, fontSize: 20, color: "primary.main" }}>
                {riskScore || data.riskScore}
              </Typography>
            </Stack>
            <Typography variant="caption" color="text.secondary" sx={{ fontSize: 12 }}>
              Media settore: {data.mediaSector}
            </Typography>
          </Box>

          <Divider />

          <Box>
            <Stack direction="row" justifyContent="space-between" alignItems="center">
              <Typography variant="body2" color="text.secondary" sx={{ fontSize: 13.5 }}>
                Fatturato
              </Typography>
              <Typography sx={{ fontWeight: 900, fontSize: 20, color: "primary.main" }}>
                {data.fatturato.toLocaleString("it-IT")}€
              </Typography>
            </Stack>
            <Typography variant="caption" color="text.secondary" sx={{ fontSize: 12 }}>
              Media settore: {data.mediaFatturato.toLocaleString("it-IT")}€
            </Typography>
          </Box>

          <Divider />

          <Box>
            <Stack direction="row" justifyContent="space-between" alignItems="center">
              <Typography variant="body2" color="text.secondary" sx={{ fontSize: 13.5 }}>
                Margine Utile Netto
              </Typography>
              <Typography sx={{ fontWeight: 900, fontSize: 20, color: "primary.main" }}>
                {data.margineUtile}
              </Typography>
            </Stack>
            <Typography variant="caption" color="text.secondary" sx={{ fontSize: 12 }}>
              Media settore: {data.mediaUtile}
            </Typography>
          </Box>
        </Stack>
      </CardContent>
    </Card>
  );
}